import React from 'react';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormLink from '../../../../library/form/components/FormLink';
// import SarasDnDCard from '../../../../library/hooks/bdnd/SarasDnDCard';
import SarasDnDCard from '../../../../library/hooks/dndkit/SarasDnDCard';
import SarasTrans from '../../../../library/notifications/SarasTrans';

const VoucherDetailRow = (props) => {
    const { formObject, index, rowKey, isSortMode } = props;
    return (
        <SarasDnDCard rowKey={rowKey} index={index} isSortMode={isSortMode}>
        <ul>
            <li className="uiColumnCenter uiColumn70">
                <span className="uiLink sortable-handle" ><SarasTrans value = "Drag"/></span>
            </li>
            <li className="uiColumnCenter uiColumn100">
                <span ></span>
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "invDate" }} />
            </li>
            <li className="uiColumnCenter uiColumn150">
                <FormLink formObject={formObject} rowKey={rowKey} className="uiLink"
                    action={{ paramName: "invNumber", actionId: "show",  containerKey: "popup" }}
                    linkProp={{ target: "_blank" }}
                ></FormLink>
            </li>
            <li className="uiColumnCenter uiColumn100">
                <span ></span>
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "invAmt" }} />
            </li>
            <li className="uiColumnCenter uiColumn100">
                <span ></span>
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "voucherAmt" }} />
            </li>
            <li className="uiColumnCenter uiColumn70">
                <span ></span>
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "voucherCur" }} />
            </li>
            <li className="uiColumnCenter uiColumn100">
                <span ></span>
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "adjustedAmt" }} />
            </li>
            <li className="uiColumnCenter uiColumn100">
                <span ></span>
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "voucherCharge" }} />
            </li>
        </ul>
        </SarasDnDCard>
    )
}

export default VoucherDetailRow
